import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-5 h-full flex flex-col overflow-hidden rounded-br-xl" }
const _hoisted_2 = { class: "pt-5 px-6" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "py-5 px-6 h-full min-h-0 overflow-y-auto border-t border-gray-200" }
const _hoisted_5 = { class: "space-y-3 overflow-auto max-h-full" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex h-full my-auto" }
const _hoisted_8 = { class: "flex flex-1 h-full my-auto" }
const _hoisted_9 = { class: "my-auto" }
const _hoisted_10 = { class: "font-semibold text-left" }
const _hoisted_11 = { class: "flex text-gray-400 text-sm" }
const _hoisted_12 = { class: "flex h-full my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ActionModal = _resolveComponent("ActionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t('views.activityTable.calendarModal.activities.header')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ActionModal, {
        "initial-step-index": 1,
        "initial-state": _ctx.actionModalInitialState,
        "step-config": _ctx.actionModalStepConfig,
        header: _ctx.actionModalHeader
      }, {
        default: _withCtx(({ open }) => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
              return (_openBlock(), _createElementBlock("button", {
                key: event.id,
                type: "button",
                class: "flex space-x-4 bg-dark-gray-200 bg-opacity-80 py-2 px-4 w-full rounded-lg h-20",
                onClick: ($event: any) => (_ctx.onEventClicked(event, open))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Icon, {
                    class: "my-auto h-12 w-12",
                    src: event.icon_url
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString((event as Record).description), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$d(_ctx.getEventDate(event), 'middle')), 1),
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "rounded-full w-1 h-1 my-auto bg-gray-400 mx-2" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(`${_ctx.$t('views.activityTable.calendarModal.activities.week')} ${_ctx.getWeekNumberfromISODateString(event)}`), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Icon, {
                    class: "my-auto h-3 w-3 mr-2",
                    src: _ctx.IconSource.Right
                  }, null, 8, ["src"])
                ])
              ], 8, _hoisted_6))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["initial-state", "step-config", "header"])
    ])
  ]))
}